import React from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

export default function WatchIcon({ isWatching, toggleWatching, isSelected }) {
  const fontSize = "1rem";
  const onColor = isSelected ? "white" : "blue";
  const offColor = isSelected ? "white" : "#cccccc";

  return (
    <div onClick={toggleWatching} style={{ cursor: "pointer" }}>
      {isWatching ? (
        <span title={"Remove from Watch List"}>
          <VisibilityIcon style={{ color: onColor, fontSize }} />
        </span>
      ) : (
        <span title={"Add to Watch List"}>
          <VisibilityOffIcon style={{ color: offColor, fontSize }} />
        </span>
      )}
    </div>
  );
}
